import styled from 'styled-components';

export const STriangle = styled.div`
width: 0;
height: 0;
border: ${props => (props.size ? props.size / 2 : 150)}px solid transparent;
border-top: 0;
border-bottom: ${props => (props.size ? props.size : 300)}px solid ${props => (props.color || 'red')};
`;
